export default Object.freeze({
	FreeText: `FreeText`,
	BlackLine: `Line`,
	Image: `Image`,
	Stamp: `stamp`,
	Ink: `Ink`,
});